const getEventLocation = (event) => {
  const gameStoreName =
    event.gameStore?.name || event.organization?.name || event.gameStoreName;
  const city = event.location?.city || event.city;
  const state = event.location?.state || event.state;
  const country = event.location?.country || event.country;

  if (!gameStoreName) return "";
  return [gameStoreName, city, state, country]
    .filter((parameter) => parameter)
    .join(", ");
};

const getEventStatus = (started, ended) => {
  return ended ? "Ended" : started ? "Started" : "Not Started";
};
// const getEventStatus = (started, ended, currentRound) => {
//   return ended
//     ? "Ended"
//     : started && currentRound > 0
//     ? "Started"
//     : "Not Started";
// };

const getEventGameSystem = (event, gameSystemDict) => {
  if (event.gameSystemId && gameSystemDict[event.gameSystemId]) {
    event.gameSystem = gameSystemDict[event.gameSystemId];
  }
  return event.gameSystem;
};

export const mapData = (data = [], gameSystemDict, moment) => {
  return data
    .sort((a, b) => {
      const endDateA = a.dates?.end || a.eventEndDate;
      const endDateB = b.dates?.end || b.eventEndDate;
      return moment(endDateB).diff(moment(endDateA));
    })
    .map((event) => {
      let pricingInfo = event.pricingInfo;
      if (!pricingInfo && event.pricingDict) {
        const keys = Object.keys(event.pricingDict);
        if (keys.length > 0) {
          pricingInfo = {
            currency: keys[0],
            amount: (event.pricingDict[keys[0]] / 100).toFixed(2)
          };
        }
      }
      return {
        ...event,
        pricingInfo,
        numberOfRounds: event.status?.numberOfRounds ?? event.numberOfRounds,
        gameSystem: getEventGameSystem(event, gameSystemDict),
        status: getEventStatus(
          event.status?.started ?? event.started,
          event.status?.ended ?? event.ended
        ),
        eventLocation: getEventLocation(event)
      };
    });
};

export const newEventParallelData = async (
  userId,
  fetchGameStores,
  getGameSystems,
  fetchUser,
  fetchLocations
) => {
  const apiGameStores = fetchGameStores();
  const apiGameSystems = getGameSystems();
  const apiUser = fetchUser(userId);
  const apiLocations = fetchLocations();

  return {
    apiGameStores: await apiGameStores,
    apiGameSystems: await apiGameSystems,
    apiUser: userId ? await apiUser : {},
    apiLocations: await apiLocations
  };
};

export const urlToString = (string) => {
  return decodeURIComponent(string);
};

export const stringToUrl = (string) => {
  return encodeURIComponent(string);
};
